const setChartType = (state, action) => {
  state.chartType = action.payload;
};

export default {
  setChartType,
};
